import React, { Component } from 'react';
import T from 'prop-types';
// components
import PageMessage from 'components/PageMessage';
// utils
import { sendNotify } from 'utils/airbrakeHelper';

// Catches a render error in the page content, reports it and shows a fallback instead of a blank app.
// Pass the current pathname as resetKey so the next route renders normally again.
class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const { currentUser, resetKey } = this.props;
    sendNotify({ error, componentStack: info?.componentStack, route: resetKey }, currentUser);
  }

  componentDidUpdate(prevProps) {
    const { resetKey } = this.props;
    const { hasError } = this.state;
    if (hasError && prevProps.resetKey !== resetKey) {
      this.setState({ hasError: false }); // eslint-disable-line react/no-did-update-set-state
    }
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (!hasError) return children;

    return (
      <PageMessage
        titleId="component.errorBoundary.title"
        descriptionId="component.errorBoundary.description"
        actionLabelId="general.refresh"
        onAction={this.handleRefresh}
      />
    );
  }
}

ErrorBoundary.propTypes = {
  children: T.node,
  currentUser: T.object,
  resetKey: T.string,
};

export default ErrorBoundary;
